export enum DialogType {
  WARNING
}
